import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const api = 'api/EmailVerify';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

export function getNeedEmailVerify() {
    return get(`${api}/needEmailVerify`);
}

export function postCheck(applId, email) {
    return post(`${api}/check`, { applId, email });
}

/**
 * 驗證OTP驗證碼
 * @param {String} otpCode 驗證碼
 * @param {String} email 接收OTP驗證碼的電子信箱
 */
export function postVerifyOTP(otpCode, email) {
    return post(`${api}/verifyOTP`, { otpCode, email });
}

/**
 * 發送OTP驗證碼
 * @param {String} email 接收OTP驗證碼的電子信箱
 */
export function postSentOTP(email) {
    return post(`${api}/sendOTP`, { email }, { ...options, errorDialog: false, repeatRequestCancel: true });
}

// 重新發送OTP驗證碼
export function postReSentOTP(email) {
    return post(`${api}/reSendOTP`, { email }, { ...options, errorDialog: false, repeatRequestCancel: true });
}
